import StoryblokClient from 'storyblok-js-client'

const Storyblok = new StoryblokClient({
    accessToken: 'LZGFxjR34cofPNlwzU6wgwtt',
    cache: {
      clear: 'auto',
      type: 'memory'
    }
})

export default Storyblok
